export default __webpack_public_path__ + "static/media/rmutsb_logo.e1b395ba.png";